<template>
  <div class="create-tab-item">
    <div
      class="quickly-create"
      v-show="getMainProfile && getMainProfile.enableFastitem"
      v-click-feedback="'deep-filter'"
      :class="{ maintenance: showMaintenanceForQuicklyCreate() }"
      @click="quicklyCreate"
    >
      <div class="create-btn">
        <svg-icon type="add" class="add" />
      </div>
    </div>

    <document-creator v-model="showQuicklyCreate" v-if="initCreator" v-body> </document-creator>

    <document-creator-v2 v-model="showQuicklyCreate2" v-if="initCreator" v-body> </document-creator-v2>
  </div>
</template>
<script type="text/ecmascript-6">
// import Loading from 'components/base-ui/loading';
const DocumentCreator = () => import('components/business/common/document-creator');
const DocumentCreatorV2 = () => import('components/business/refactor-main/document-creator');
import {mapGetters, mapState} from 'vuex';
import {isStopService} from 'service/main';
import config from 'config';

let QuicklyCreateImage = require('assets/images/refactor-main/quickly-create@2x.png');

export default {
  name: 'create-tab-item',
  data() {
    return {
      QuicklyCreateImage,
      showQuicklyCreate: false,
      showQuicklyCreate2: false,
      initCreator: false
    };
  },
  computed: {
    ...mapState({
      token: state => state.token,
    }),
    ...mapGetters([
      'getMainProfile',
      'getQuickMenu',
      'getStopAnnouncement'
    ]),
  },
  created() {
    setTimeout(() => {
      this.initCreator = true;
    }, 500);
  },
  methods: {
    showMaintenanceForQuicklyCreate() {
      let quickMenu  = this.getQuickMenu['SCAN_OTHER'];
      let quickCreate = quickMenu && quickMenu['QUICK_CREATE'];
      let stopAnnouncement = this.getStopAnnouncement;
      if (quickCreate) {
        return isStopService(stopAnnouncement) && !quickCreate.isWhitelist;
      }
      else {
        return false;
      }
    },

    quicklyCreate() {
      if (!this.token) return;

      if (this.showMaintenanceForQuicklyCreate()) {
        this.$plugins.maintenance.show();
        return;
      }

      let myInfo = this.$store.getters.getMyInfo;
      //新瑞鹏宠物医疗集团有限公司
      let tenantIds = ['1476748409506553857', '994029360664702978',
        '994033346768035841', '1458672055980392450'];
      let envList = ['prod'];
      if (envList.indexOf(config.env) === -1 || (true || myInfo && tenantIds.indexOf(myInfo.tenantId) > -1)) {
        this.showQuicklyCreate2 = true;
      } else {
        this.showQuicklyCreate = true;
      }
    },
  },
  components: {
    // Loading,
    DocumentCreator,
    DocumentCreatorV2,
  }
};
</script>
<style lang="scss" scoped>
@import '~assets/css/variable.scss';
@import '~assets/css/common.scss';

.quickly-create {
  line-height: px(88);
  font-size: 0;
  &.maintenance {
    opacity: 0.4;
  }
  .quickly-create-image {
    vertical-align: middle;
    width: px(130);
  }
  .create-btn {
    width: 102px;
    height: 68px;
    background-color: $mainColor;
    border-radius: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    .add {
      font-size: 32px;
      color: #fff;
    }
  }
}
</style>
